import {useQuery} from "@tanstack/react-query";
import {getData} from "../../../app/getters/getData.js";

export const useKonfiguracja = (enabled = true) => {


    return useQuery({
        queryKey: ["konfiguracja_list"],
        queryFn: async () => getData('/config'),
        enabled: enabled
    })
}